module.exports = __webpack_public_path__ + "static/media/trend portfolio COVER.304a8c2f.png";